import { Directive, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import intlTelInput, { Iti } from 'intl-tel-input';

@Directive({
  selector: '[appIntlTelInput]'
})
export class IntlTelInputDirective implements OnInit, OnDestroy {
  @ViewChild('mobileSignin', { static: true }) phoneInput: ElementRef;
  private iti: any;

  constructor(private el: ElementRef) { }

  ngOnInit() {
    if(this.el && this.el.nativeElement){
      try {
        this.iti = intlTelInput(this.el.nativeElement, {
          allowDropdown: true,
          dropdownContainer: document.body,
          autoPlaceholder: "polite",
          initialCountry: "za",
          separateDialCode: true
          // utilsScript removed - handled by app module import
        });
      } catch (error) {
        console.error('Error initializing intl-tel-input:', error);
      }
    }
  }

  ngOnDestroy() {
    if (this.iti) {
      this.iti.destroy();
    }
  }

  get itiInstance() {
    return this.iti;
  }
}
